import React, { Component } from "react";
import { ListingContext } from "../../Context";
import _ from "lodash";

import { Title } from "../../utils/consts";

import LocationScoreCard from "../../components/locationScoreCard/LocationScoreCard";
import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingScore extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const locationScore = listing.locationScore || {};
          const priceScore = listing.priceScore || {};
          if (!!listingContext.loading) {
            return (
              <div className="listing-location-score">
                <SkeletonText lines={1} />
              </div>
            );
          } else if (!_.isEmpty(locationScore) || !_.isEmpty(priceScore)) {
            return (
              <div className="listing-location-score">
                <h5 className="listing-section__title">{Title} Score</h5>
                <LocationScoreCard height={"480px"} />
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingScore.js